import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { creatorsReportEndpointIds } from 'root/src/shared/creatorsReport/creatorsReport.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
export const getCreatorsReportStatusEndpoint = {
    [creatorsReportEndpointIds.GET_CREATORS_REPORT_STATUS]: {
        endpointType: otherEndpointType,
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
    },
};
